



















import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IProposal, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'projectStatus',
  }),
  mixins: [paginationMixin],
})
export default class ProjectStatusList extends Vue {
  @Action('getEntities', { namespace: 'projectStatus' })
  getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'projectStatus' })
  entitiesSlice: IProposal[];
  @State('pageParams', { namespace: 'projectStatus' }) pageParams: IPageParams;
  headers = [{ text: 'Название', value: 'name' }];
  selected = [];
  interval = null;
  created() {
    this.getEntities();
  }
}
